export class CalendarOptionsModel {

  buttonText: {
    today: string;
  }
  monthNamesShort: string[];
  dayNamesShort: string[];
  eventRender: any;
  firstDay: number;
  displayEventTime: boolean;
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/calendar/calendar-options.model.ts